/***************************************************************
 * Copyright (c) 2006 - 2022, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 04/19/2022
 *
 * @version 0.1
 * Revisions:
 * 04/19/2022 - BW - Initial Creation
 *
 * Description/Purpose:
 * Payment Load Table Data Response JSON DTO
 ***************************************************************/
import TableAjaxResponseJsonDto from "dto/table-ajax-response-json-dto";


export default class PaymentTableAjaxResponseJsonDto extends TableAjaxResponseJsonDto {
  constructor(obj) {
    super(obj);
    if (obj) Object.assign(this, obj);
  }

  get multipleOrganization() {
    return this._multipleOrganization;
  }

  set multipleOrganization(newMultipleOrganization) {
    this._multipleOrganization = newMultipleOrganization;
  }

}
